export { Heading } from './Heading';
export type { HeadingProps } from './Heading';
export { Text } from './Text';
export type { TextProps } from './Text';
export { ButtonText } from './ButtonText';
export type { ButtonTextProps } from './ButtonText';
export { Label } from './Label';
export type { LabelProps } from './Label';

